import React, { Fragment } from 'react';
import { PrivacyHelmet } from '../components/MoiPayHelmet';
import PrivacyScreen from '../components/privacy/PrivacyScreen';

export default function Privacy() {
  return (
    <Fragment>
      <PrivacyHelmet />
      <PrivacyScreen />
    </Fragment>
  );
} 